import React from 'react'
import { StyledDisclaimer } from './style'

export const Disclaimer = () => {
	return (
		<StyledDisclaimer>
			This site is not affiliated, associated, authorized, endorsed by, or in any way officially connected with
			the Hasbro, or any of its subsidiaries or its affiliates.{' '}
		</StyledDisclaimer>
	)
}
